import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Resumen mensual de nóminas desde contabilidad (V_Asientos_Nominas).
 * @param {{ year: number, empresa?: 'stage'|'erna'|'fusion' }} params
 */
export async function fetchNominasResumen({ year, empresa = "stage" }) {
  const res = await axios.get(`${API_URL}/api/nominas/resumen`, {
    params: { year, empresa },
    headers: authHeaders(),
  });
  return res.data;
}

/**
 * Guarda un ajuste visual de nóminas (compartido entre usuarios, por año/empresa).
 */
export async function saveNominasAjuste({
  year,
  empresa = "stage",
  ajusteId,
  descuentoMensual,
  activo,
}) {
  const res = await axios.post(
    `${API_URL}/api/nominas/ajustes`,
    { year, empresa, ajusteId, descuentoMensual, activo },
    { headers: authHeaders() },
  );
  return res.data;
}

/**
 * Gastos mensuales en tarjetas por titular.
 * @param {{ tipo: 'debito'|'credito'|'revolut', year: number, empresa?: 'stage'|'erna'|'fusion' }} params
 */
export async function fetchNominasTarjetas({
  tipo = "revolut",
  year,
  empresa = "stage",
}) {
  const res = await axios.get(`${API_URL}/api/nominas/tarjetas`, {
    params: { tipo, year, empresa },
    headers: authHeaders(),
  });
  return res.data;
}

/** @deprecated Usar fetchNominasTarjetas({ tipo: 'credito', ... }) — antes 555 se llamaba «débito» */
export async function fetchNominasTarjetasDebito(params) {
  return fetchNominasTarjetas({ ...params, tipo: "credito" });
}
